import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type OrganizationDeletionFailedAction = {
	type: 'ORGANIZATION_DELETION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): OrganizationDeletionFailedAction => ({
	type: 'ORGANIZATION_DELETION_FAILED',
	payload,
});
